import { Settings } from './../enums/system-settings.enum';
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ApiClientService } from 'src/app/@core/services/api-client.service';
import { BaseFucntionsService } from 'src/app/@core/services/base-functions.service';
import { environment } from 'src/environments/environment';
import { ApplicationRoutes } from '../routes/application-routes.const';
import { IdentityModel } from '../models/identity.model';
import { isUnifiedCode, resolveIdentity, UNIFIED_CODE_ROOT_CLASS } from '../design/unified-code-tokens';

@Injectable({
  providedIn: 'root',
})
export class IdentityService extends BaseFucntionsService<IdentityModel> {
  constructor(apiClient: ApiClientService, private titleService: Title,) {
    super(ApplicationRoutes.Identity.Controller, apiClient);
  }
  private identity: IdentityModel = {} as any;
  identityPrefix = environment.identityResource;
  setIdentity() : Promise<any>{
    return new Promise<void>((resolve, reject) => {
      this.getList().subscribe((result: IdentityModel) => {

        const lang = localStorage.getItem('exab-lang') ?? 'ar';
        if(result){
          this.identity = resolveIdentity(result);
          document.documentElement.classList.toggle(UNIFIED_CODE_ROOT_CLASS, isUnifiedCode(this.identity));

          // Set Tab Title
          if(result.organizationName)
          {
            const title = lang === 'ar' ? result.organizationNameAr : result.organizationName;
            this.titleService.setTitle(title);
          }else {

            this.titleService.setTitle(lang === 'ar'  ? 'اكساب' : 'exaab');
          }


          // Set Tab icon
          if(result.icon){
            let link: any = document.querySelector('link[rel~=\'icon\']');
            if (!link) {
                link = document.createElement('link');
                link.rel = 'icon';
                document.getElementsByTagName('head')[0].appendChild(link);
            }
            link.href = this.identityPrefix + result.icon;
          }

          // Set Colors
          const colors = new Map([
            ['identity-primary-25', this.identity.colorOne + 25],
            ['identity-primary-80', this.identity.colorOne + 80],
            ['identity-primary-400', this.identity.colorOne],
            ['identity-primary-500', this.identity.colorTwo],
            ['color-green', this.identity.colorTwo],
            ['color-green-61', this.identity.colorTwo + 61],
            ['identity-background', this.identity.colorThree],
          ]);

          Array.from(colors.entries()).forEach(([name, value]) => {
            document.body.style.setProperty(`--${name}`, value);
          });
          resolve();
        }else {
          this.titleService.setTitle(lang === 'ar' ? 'إكساب' : 'Exaab');
        }
        resolve()
      },
      () => resolve());
    });
  }

  getIdentityModel(){
    return this.identity;
  }

  isUnifiedCode(): boolean {
    return isUnifiedCode(this.identity);
  }
}

export function setIdentity(service: IdentityService){
  return (): Promise<any> => {
    return service.setIdentity();
  }
}
